export default class RatingsState {
    stack!: StackType;
     error: boolean;
     submit: boolean;
}

export enum StackType {
    EXIT = -1,
    RATING_PANEL = 0,
    COMMENT_PANEL = 1,
    THANKYOU_PANEL = 2,
}
